export enum AplParameter {
  Unknown = -1,
  NULL = 100, //	Central\Backup database in use (value=0 on local, or param does not exist)
  FileFormat = 300, //	One Log File Per Days
  MaxPassNumber = 200, //	pass number in printing department
  HideRawMaterial = 2100, //	Hide Checkbox for Raw Material
  HideOrgMaterial = 2150, //	Hide Original Material
  BatchTime = 2000, //	Work order batch start time
  OverProductionLimit = 2500, //	OverProductionLimit
  ProductionConfirmation = 3500, //	Production Confirmation
  ManualBatch = 3600, //	Manual batch generation
  AllowQuantityInput = 3700, //	AllowQuantityInput
  AllowPartialConsumption = 4600, //	AllowPartialConsumption
  BillOfBatches = 3800, //	Bill of Batches check
  LabelTraceability = 3701, //	LabelTraceability
  MultipleConsumption = 3900, //	MultipleConsumption
  InlineConsumption = 4000, //	Inline Consumption
  ConsAllStatuses = 4100, //	Allow all statuses in consumption
  TraceabilityGrid = 4500, //	TraceabilityGrid
  ConsumptionComments = 4400, //	ConsumptionComments
  ShowCommentDelete = 4901, //	ShowCommentDelete
  NoCopiesRO = 4902, //	NoCopiesRO
  ShowBatchInsteadOfLot = 4903, //	ShowBatchInsteadOfLot
  PalRankWOBased = 4300, //	PalRankWOBased
  MaxIssuedPallets = 4601, // Max open issued pallets per workorder
  MaxIssuedPalletsConfirmConsume = 4700, // Asks if close previosly issued when maxIssued reached
  ConsumptionShowBlockedPalletInfo = 4701, // Shows info about blocked pallets and defects when issuing
  ConsumptionShowGoodPalletInfo = 4702, // Shows info about good pallets into when issuing
  HideSaveButtonPrint = 3400, //	HideSaveButtonPrint
  HideBlockPackaging = 3200, //	HideBlockPackaging
  HideBlockQI = 3300, //	HideBlockQI
  LotManual = 4900, //	LotManual
  ShowBillOfMaterials = 4800, //	ShowBillOfMaterials
  HidePalletStatusPageButtons = 4905, //	HidePalletStatusPageButtons
  ScanSSCC = 5100, //	ScanSSCC
  DefectLabel = 5000, //	DefectLabel
  InitialsMouldMandatory = 5001, //	InitialsMouldMandatory
  Merck = 5002 // Merck specific site (also needs MerckPrint UserPermission)
};
